import { Injectable } from "@nestjs/common";
import { CreateQuestion } from "../entities/create-question";
import { CreateQuestionBankReqModel } from "@boi/shared-models";

@Injectable()
export class CreateQuestionAdapter {
    public convertDtoToEntity(dto: CreateQuestionBankReqModel,): CreateQuestion {
        const question = new CreateQuestion();
        question.class = dto.classId;
        question.language = dto.language;
        question.subject = dto.subject;
        question.chapter = dto.chapter;
        question.topic = dto.topic;
        question.qno = dto.qno;
        question.qtype = dto.questionType;
        question.complexity = dto.difficultyLevel;
        question.marks = dto.marks;
        question.question = encodeURIComponent(dto.question);
        question.username = dto.userName;
        question.approvedby = dto.approvedBy;
        question.timestamp = dto.timeStamp;
        question.etimestamp = dto.etimeStamp;
        question.estatus = dto.eStatus;
        return question
    }

}